import type { ReactNode } from "react";
import { useEffect } from "react";

import { appContext } from "@provider/app-context";
import { userIdentityStore } from "@provider/user-identity";
import { Store } from "../store";
import { UserTypes } from "@courses-models/user/src/ts/models/UserModel";

export function AppContextProvider(props: {
  store: Store | undefined;
  children: ReactNode | ReactNode[];
}): React.JSX.Element {
  useEffect(() => {
    const contextState = {
      app: {
        name: "Forløbsbygger",
      },
      publisher: "gyldendal",
      product: {
        id: props.store?.course.id ?? "",
        isbn: "",
        type: "forløbsbygger",
        title: props.store?.course.title ?? "",
        subject: undefined,
        gradesLabel: undefined,
        classLabel: undefined,
        audience: "Website",
      },
    } as const;

    appContext.dispatch(appContext.actions.init(contextState));
  }, [props.store?.course.id, props.store?.course.title]);

  useEffect(() => {
    props.store?.user.getUserType(props.store.course.id).then((role) => {
      if (props.store?.user) {
        userIdentityStore.dispatch(
          userIdentityStore.actions.setUser({
            id: props.store.user.id,
            name: props.store.user.name,
            role: role === UserTypes.TEACHER ? "teacher" : "student",
            authenticationProvider: "uniLogin",
          }),
        );
      }
    });
  }, [props.store?.user]);

  return <>{props.children}</>;
}
